import React from "react";
import AdminPanelLayout from "../../../components/AdminPanel/AdminPanelLayout/AdminPanelLayout";
import AllInterviewLogsCardView from "../../../components/AdminPanel/InterviewLogs/AllInterviewLogsCardView";

const InterviewLogs = () => {
  return (
    <AdminPanelLayout>
      <AllInterviewLogsCardView />
    </AdminPanelLayout>
  );
};

export default InterviewLogs;

